import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      let serviceuser = 'certinergie';
      let servicepass = 'certinergie';
      let authorization = '';
      if (serviceuser.length != 0 && servicepass.length != 0)
      {
          // Build auth string
          authorization = btoa(serviceuser + ':' + servicepass);
      }
      req = req.clone({
          setHeaders: {
              'Authorization': 'Basic ' + authorization
          },
      });
      console.log('AuthInterceptor');
//      console.log(req);
      return next.handle(req);
  }
}


// WEBPACK FOOTER //
// ./src/app/auth.interceptor.ts